module.exports = __webpack_public_path__ + "static/media/close.ca028cb4.svg";